import {
    GET_HISTORY_ACCESS_GPS_REQUEST,
    GET_HISTORY_ACCESS_GPS_SUCCESS_FIXED,
    GET_HISTORY_ACCESS_GPS_FAILURE,
} from "../actions/history";

const initialState = {
    fetching: false,
    history: null,
    totalHistory: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_HISTORY_ACCESS_GPS_REQUEST: {
            return {
                ...state,
                fetching: true,
                history: null
            };
        }
        case GET_HISTORY_ACCESS_GPS_SUCCESS_FIXED: {

            return {
                ...state,
                fetching: false,
                history: action.payload.history,
                totalHistory: action.payload.total
            };
        }
        case GET_HISTORY_ACCESS_GPS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        default:
            return state;
    }
};
